import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

// Imports using numbered brand files for proper ordering
import apple from '../../../assets/brands/1-Apple.png';
import alienware from '../../../assets/brands/2-Alienware.jpeg';
import asusRog from '../../../assets/brands/3-ASUS ROG.png';
import acerPredator from '../../../assets/brands/4-Acer Predator.png';
import beats from '../../../assets/brands/5-Beats.png';
import bose from '../../../assets/brands/6-BOSE logo.png';
import google from '../../../assets/brands/7-Google Pixel.jpg';
import hpOmen from '../../../assets/brands/8-HP OMEN.png';
import ifb from '../../../assets/brands/9-IFB Logo.png';
import jbl from '../../../assets/brands/10-JBL.jpg';
import lenovoLegion from '../../../assets/brands/11-Lenovo Legion.jpg';
import nothing from '../../../assets/brands/21-nothing.webp';
import microsoft from '../../../assets/brands/13-Microsoft.jpg';
import motorola from '../../../assets/brands/14-motorola.png';
import msi from '../../../assets/brands/15-MSI.png';
import nvidia from '../../../assets/brands/16-nvidia.png';
import samsung from '../../../assets/brands/17-Samsung.png';
import sony from '../../../assets/brands/18-sony.png';
import vu from '../../../assets/brands/19-Vu.png';
import wanbo from '../../../assets/brands/20-wanbo.png';

function Brands() {
  const navigate = useNavigate();
  const brandsData = [
    { name: "APPLE", logo: apple },
    { name: "ALIENWARE", logo: alienware },
    { name: "ROG", logo: asusRog },
    { name: "PREDATOR", logo: acerPredator },
    { name: "BEATS", logo: beats },
    { name: "BOSE", logo: bose },
    { name: "G PIXEL", logo: google },
    { name: "OMEN", logo: hpOmen },
    { name: "IFB", logo: ifb },
    { name: "JBL", logo: jbl },
    { name: "LEGION", logo: lenovoLegion },
    { name: "MICROSOFT", logo: microsoft },
    { name: "MOTOROLA", logo: motorola },
    { name: "MSI", logo: msi },
    { name: "NVIDIA", logo: nvidia },
    { name: "SAMSUNG", logo: samsung },
    { name: "SONY", logo: sony },
    { name: "VU", logo: vu },
    { name: "WANBO", logo: wanbo },
    { name: "NOTHING", logo: nothing },
  ];

  return (
    <BrandsContainer>
      <GridContainer>
        {brandsData.map((brand, index) => (
          <BrandCard key={index}>
            <ImageContainer>
              <BrandImage src={brand.logo} alt={brand.name} />
            </ImageContainer>
          </BrandCard>
        ))}
      </GridContainer>

      
      <BrandsDisclaimer>
        The Logos shown above are the property of their companies. The use of these Logos does not imply any affiliation with or endorsement by the companies (unless specified). All rights to the Logos are retained by the respective companies, and the use is strictly for illustrative purposes in the context of curation of deals on the products/services offered by Spoelt.
      </BrandsDisclaimer>
    </BrandsContainer>
  );
}

const BrandsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  margin-top: 60px; // Standard top padding for grid
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
  border-top: 1.5px solid rgba(32, 32, 35, 0.2); // Border opacity 20%
  border-left: 1.5px solid rgba(32, 32, 35, 0.2);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const BrandCard = styled.div`
  aspect-ratio: 1 / 1;
  border-right: 1.5px solid rgba(32, 32, 35, 0.2); // Border opacity 20%
  border-bottom: 1.5px solid rgba(32, 32, 35, 0.2);
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.2s ease;
  cursor: pointer;
  background-color: #FFFFFF;

  &:hover {
    background-color: #F7F7F5;
  }

  @media (max-width: 991px) {
    padding: 20px;
    aspect-ratio: auto;
    min-height: 140px;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BrandImage = styled.img`
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
`;


const BrandsDisclaimer = styled.p`
  padding: 60px 40px;
  font: 400 12px/1.4 Metrophobic, sans-serif;
  color: #828282;
  text-align: center;
  margin: 0;
`;

export default Brands;